import React from 'react'
import Badge from '../Components/Badge'
import SectionTitle from '../Components/SectionTitle'
import ServiceCard from '../Components/ServiceCard'
import Footer from '../Components/Footer'
import '../assets/css/service.css'
function Service() {
  return (
    <div className='service-ssc' style={
        {
            maxWidth:"1200px",
            margin:"0 auto"

        }
    }>
      <Badge title="Services Serve By Me" />

          <SectionTitle sectitle="Turning complex problems into simple design" />

          <div id="portfolio-sec">
            <ServiceCard
              title="Website Design & Development"
              tech="HTML"
              desc="I create fast, responsive, and visually appealing websites tailored to your brand using modern web technologies and clean, SEO-friendly code."
            />

            <ServiceCard
              title="Responsive Landing Page"
              tech="Student"
              desc="I design high-converting, mobile-friendly landing pages that load fast, look stunning, and effectively capture leads or drive user actions."
            />

            <ServiceCard
              title="E-Commerce Website Development"
              tech="PHP"
              desc="I build secure, user-friendly e-commerce websites with product management, cart, checkout, payment gateway, and responsive design for seamless shopping."
            />

            <ServiceCard
              title="Admin Panel & Dashboard Development"
              tech="PHP"
              desc="I develop powerful admin panels with user roles, real-time data, CRUD operations, and analytics for efficient website or app management."
            />

            <ServiceCard
              title="CMS Integration"
              tech="Web"
              desc="I integrate custom or open-source CMS platforms to easily manage website content, blogs, images, and dynamic pages without coding."
            />

            <ServiceCard
              title="Graphic Design"
              tech="Logo Banner"
              desc="I create visually appealing logos, banners, posters, and social media creatives that enhance branding, engagement, and overall visual identity."
            />
          </div>
          <Footer/>
    </div>
  )
}

export default Service
